import axios from 'axios'
import CoustomUrls from '../../../urls';

export let adminApproveRejectReviewAPI = (reviewKey, reviewStatus) => {
    return axios.post(CoustomUrls.ApproveRejectReview,
            {
                    ReviewKey: reviewKey,
                    ReviewStatus: reviewStatus    
            }
        ).then( results => results)
    }